import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridCellDirective } from './grid-cell.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GridCellDirective
  ],
  exports: [
    GridCellDirective
  ]
})
export class GridCellModule { }
